<template>
  <a-modal destroyOnClose style="height: 80%;overflow-y: auto;" width="80%" v-model="visible" @cancel="close" @ok="handleOk" cancelText="关闭" okText="提交" :closable="false" :destroyOnClose="true" :maskClosable="false">
    <a-row slot="title" style="margin-bottom: 10px">
      <a-row>
        理解题
      </a-row>
    </a-row>
    <a-spin :spinning="loading">
      <a-row>
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="是否必做">
            <a-radio-group :options="requiredOptions" v-model="drill.required"/>
          </a-form-model-item>
          <a-form-model-item label="题干">
            <a-textarea style="width: 80%" v-model="drill.text" placeholder="请输入题干"/>
          </a-form-model-item>
          <a-form-model-item label="题干音频" v-if="subType == 602">
            <AudioUpload :defaultUrl="drill.audioUrl ? `${drill.audioUrl}`: undefined" @changeUri="changeAudioUri" path="audio/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="题干视频" v-if="subType == 602">
            <VideoUpload :defaultUrl="drill.videoUrl ? `${drill.videoUrl}`: undefined" @changeUri="changeVideoUri" path="audio/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="题图">
            <CommonUpload :defaultUrl="this.drill.imageUrl ? `${this.drill.imageUrl}`: undefined" @changeImgUri="changeImgUri" path="img/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="小题（可多选）">
            <a-row v-for="(question, questionIndex) in drill.questionList" :key="questionIndex" style="margin-top: 32px;">
              <a-row>
                
                <a-col span="2">
                  <a-icon
                    class="dynamic-delete-button"
                    type="minus-circle-o"
                    @click="removeQuestion(questionIndex)"/>
                  {{ questionIndex + 1 }}小题、
                </a-col>
                <a-col span="14">
                  <a-textarea style="width: 100%" v-model="question.text" :placeholder="`请输入${questionIndex + 1}小题题干`"/>
                  <a-row v-for="(option, optionIndex) in question.optionList" :key="optionIndex">
                    <span>{{ letter[optionIndex] }}. </span>
                    <a-input style="width: 60%" v-model="option.text" placeholder="请输入选项文字"/>
                    <a-checkbox style="margin-left: 10px;" v-model="option.correctAnswer">
                      <a-tag v-if="option.correctAnswer" color="green">
                        正确
                      </a-tag>
                      <a-tag v-else color="red">
                        错误
                      </a-tag>
                    </a-checkbox>
                    <a-icon
                      v-if="question.optionList.length > 1"
                      class="dynamic-delete-button"
                      type="minus-circle-o"
                      @click="removeOption(questionIndex, optionIndex)"/>
                  </a-row>
                  <a-button type="dashed" style="width: 100%" @click="() => addOption(questionIndex)">
                    <a-icon type="plus" />增加选项
                  </a-button>
                  <a-textarea style="width: 100%" v-model="question.explanation" :placeholder="`解析`"/>
                </a-col>
              </a-row>
            </a-row>
          </a-form-model-item>
          <a-form-model-item v-bind="formItemLayoutWithOutLabel">
            <a-button type="dashed" style="width: 80%" @click="addQuestion">
              <a-icon type="plus" />增加小题
            </a-button>
          </a-form-model-item>
          <a-form-model-item label="解析">
            <a-textarea style="width: 80%" v-model="drill.explanation" placeholder="请输入解析"/>
          </a-form-model-item>
        </a-form-model>
      </a-row>
    </a-spin>
  </a-modal>
</template>

<script>
import {mapActions} from "vuex";
const OSS = require('ali-oss')
const letter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
import PassageChoiceDrillApi from '../../../../api/src/drill/api/PassageChoiceDrillApi.js'
const passageChoiceDrillApi = new PassageChoiceDrillApi()
import CommonUpload from '../../../../components/CommonUpload.vue'
import AudioUpload from '../../../../components/AudioUpload.vue'
import VideoUpload from '../../../../components/VideoUpload.vue'
import { deepClone } from '@clownlee/utils'

export default {
  name: "PassageChoiceEdit",
  props: {
    visibleTimes: Number,
    info: Object,
    treeData: Array,
    subType: Number,
    selectedKeys: Array,
    currentDrillId: String,
    sectionId: String,
  },
  components: {CommonUpload, AudioUpload, VideoUpload},
  watch: {
    'visibleTimes': async function(a, b) {
      this.visible = true
      if(this.currentDrillId){
        console.debug(this.currentDrillId)
        this.loading = true
        let resp = await passageChoiceDrillApi.getDetail(this.currentDrillId)
        console.log(resp)
        this.drill = this.normalizeDrillDetail(resp)
        this.loading = false
        return
      }
    },
  },
  data() {
    return {
      letter: letter,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },
      requiredOptions: [{
        value: false,
        label: '否'
      },{
        value: true,
        label: '是'
      }],
      drill: {
        required: false,
        text: undefined,
        imageUri: undefined,
        audioUri: undefined,
        videoUri: undefined,
        questionList: [],
        explanation: undefined,
      },
      loading: false,
      visible: false
    }
  },
  methods:{
    normalizeDrillDetail(drill) {
      const data = deepClone(drill)
      if (!Array.isArray(data.questionList)) {
        return data
      }
      data.questionList.forEach((question) => {
        const optionList = question.optionList || []
        const answerIds = new Set(
          (Array.isArray(question.correctAnswer) ? question.correctAnswer : []).map((id) => String(id))
        )
        if (answerIds.size > 0) {
          optionList.forEach((option, optionIndex) => {
            const optionId = option.id != null ? String(option.id) : letter[optionIndex]
            option.correctAnswer = answerIds.has(optionId)
          })
        } else {
          optionList.forEach((option) => {
            if (option.correctAnswer !== true && option.correctAnswer !== false) {
              option.correctAnswer = false
            }
          })
        }
      })
      return data
    },
    async changeAudioUri(uri) {
      this.drill.audioUri = uri
    },
    async changeVideoUri(uri) {
      this.drill.videoUri = uri
    },
    addQuestion() {
      let questionList = deepClone(this.drill.questionList)
      questionList.push({
        text: undefined,
        explanation: undefined,
        imageUrl: undefined,
        imageUri: undefined,
        correctAnswer: undefined,
        optionList: [{
          text: undefined,
          correctAnswer: false
        },{
          text: undefined,
          correctAnswer: false
        },{
          text: undefined,
          correctAnswer: false
        },{
          text: undefined,
          correctAnswer: false
        }]
      })
      this.drill.questionList = questionList
    },
    removeOption(questionIndex, optionIndex) {
      let questionList = deepClone(this.drill.questionList)
      questionList[questionIndex].optionList.splice(optionIndex, 1)
      this.drill.questionList = questionList
    },
    addOption(questionIndex) {
      let questionList = deepClone(this.drill.questionList)
      questionList[questionIndex].optionList.push({
        text: undefined,
        correctAnswer: false
      })
      this.drill.questionList = questionList
    },
    removeQuestion(questionIndex) {
      let questionList = deepClone(this.drill.questionList)
      questionList.splice(questionIndex, 1)
      this.drill.questionList = questionList
    },


    changeImgUri(uri) {
      this.drill.imageUri = uri
      console.log(uri)
    },
    changeOptionImgUri(index, uri) {
      console.log(index, uri)
      this.drill.optionList[index].imageUri = uri
    },
    close() {
      if(this.loading){
        this.$message.warning('试题正在上传中，请稍后')
        return
      }
      this.$emit('success', {addDrill: true})
      this.visible = false
      this.drill = {
        required: false,
        text: undefined,
        imageUri: undefined,
        audioUri: undefined,
        videoUri: undefined,
        questionList: [],
        explanation: undefined,
      }
    },
    async handleOk() {
      console.log(this.drill)
      let drill = deepClone(this.drill)
      if(!drill.text){
        this.$message.error('请填写题干')
        return
      }
      if(!drill.questionList || drill.questionList.length == 0) {
        this.$message.error('请增加小题')
        return
      }
      for(let i = 0; i < drill.questionList.length; i++){
        if(!drill.questionList[i].text){
          this.$message.error(`请填写${i + 1}小题题干`)
          return
        }
        let correctAnswer = []
        for(let j = 0; j < drill.questionList[i].optionList.length; j++){
          drill.questionList[i].optionList[j].id = letter[j]
          if(!drill.questionList[i].optionList[j].text){
            this.$message.error(`请填写${i + 1}小题第${j + 1}个选项`)
            return
          }
          if(drill.questionList[i].optionList[j].correctAnswer) {
            correctAnswer.push(drill.questionList[i].optionList[j].id)
          }
        }
        if(!correctAnswer || correctAnswer.length < 1){
          this.$message.error(`请选择${i + 1}小题正确答案（可多选）`)
          return
        }
        drill.questionList[i].correctAnswer = correctAnswer
      }
      drill.correctAnswer = drill.questionList.map((question) => question.correctAnswer || [])
      if(!drill.id){
        drill.subType = this.subType
      }
      console.debug(drill)
      console.debug(this.$route.params.courseStandardId)
      console.debug(this.selectedKeys[0])
      this.loading = true
      if(!drill.id){
        await passageChoiceDrillApi.create(drill, {
          courseStandardId: this.$route.params.courseStandardId,
          knowledgeId: this.selectedKeys[0],
          sectionId: this.sectionId,
          sortKey: 0
        })
      }else{
        await passageChoiceDrillApi.update(drill.id, drill)
      }
      this.visible = false
      this.drill = {
        required: false,
        text: undefined,
        imageUri: undefined,
        audioUri: undefined,
        videoUri: undefined,
        questionList: [],
        explanation: undefined,
      }
      this.loading = false
      this.$emit('success', {addDrill: true})
    },
  }
}
</script>

<style scoped lang="less">
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 10px;
}
.dynamic-delete-button:hover {
  color: #777;
}
</style>